export const LUDOLIO_WEBSITE_URL = 'https://www.ludolio.com';
export const LUDOLIO_AUTH_APP_URL = 'https://auth.ludolio.com';
export const LUDOLIO_AUTH_APP_DEV_URL = 'http://localhost:5176';
export const LUDOLIO_API_ORIGIN = 'https://api.ludolio.com';
export const LUDOLIO_GAMES_SITE_URL = 'https://games.ludolio.com';
export const LUDOLIO_LOGO_URL = `${LUDOLIO_AUTH_APP_URL}/logo.png`;
export const LUDOLIO_PRIVACY_POLICY_URL = `${LUDOLIO_WEBSITE_URL}/privacy-policy`;
export const LUDOLIO_TERMS_OF_USE_URL = `${LUDOLIO_WEBSITE_URL}/terms-of-use`;
export const LUDOLIO_HOW_IT_WORKS_URL = `${LUDOLIO_WEBSITE_URL}/how-it-works`;
export const LUDOLIO_ACCESSIBILITY_URL = 'https://orgadmin.ludolio.com/docs/accessibility';
export const LUDOLIO_SUPPORT_EMAIL = 'support@ludolio.com';
export const LUDOLIO_PRIVACY_EMAIL = 'privacy@ludolio.com';
